import { Box, Typography } from "@mui/material"
import { theme } from "../../../../utils/theme/godzilla_light";
import { EDUCATION_HUB_CONTENT_MAX_WIDTH } from "../../constants"
import { Trans, useTranslation } from "react-i18next";
import GAIrreversibleImage from '../../../../assets/images/svgs/identifyingGA/irreversible.png.svg';
import TransMsg from './transMessage';

const styles = {
    imageBox: {
        paddingTop: "24px",
        width: "100%",
        height: "auto",
        maxWidth: "749px",
        maxHeight: "351px"
    }
}
const VisionLoss = () => {
    const { t } = useTranslation()

    const visionLossData = {
        title: t(TransMsg.GA_IRREVERSIBLE_TITLE),
        subTitle: t(TransMsg.GA_IRREVERSIBLE_SUB_TITLE),
        description: t(TransMsg.GA_IRREVERSIBLE_DESCRIPTION),
        imageUrl: GAIrreversibleImage,
        imageDescription: t(TransMsg.GA_IRREVERSIBLE_IMAGE_DESC)
    }

    return (
        <Box textAlign={"center"} px="31px" pt={"40px"} pb="37px" sx={{ backgroundColor: "#F8F8F8" }} display="flex" flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
            <Box maxWidth={EDUCATION_HUB_CONTENT_MAX_WIDTH} width="100%">
                <Typography sx={{ ...theme.typography.components.sectionTitle }}>
                    {visionLossData.title}
                </Typography>

                <Typography sx={{ ...theme.typography.components.sectionTitle }}>
                    <Trans
                        i18nKey={visionLossData.subTitle}
                        components={{ sup: <sup /> }} />
                </Typography>

                <Typography sx={{ ...theme.typography.components.sectionDescription, mt: "24px" }}>
                    <Trans
                        i18nKey={visionLossData.description}
                        components={{ sup: <sup /> }}
                    />
                </Typography>
                <img src={visionLossData.imageUrl} alt="ga-irreversible" style={styles.imageBox} />
                <Typography sx={{ ...theme.typography.poppinsBodyLight, fontSize: "16px", mt: "24px", fontStyle: "italic" }}>
                    <Trans
                        i18nKey={visionLossData.imageDescription}
                        components={{ sup: <sup /> }}
                    />
                </Typography>
            </Box>
        </Box>
    )
}

export default VisionLoss